import React, { ReactNode } from 'react';

export default function Button({
  classes,
  handleDialogToggle,
  children,
}: {
  classes: string,
  handleDialogToggle: (show: boolean) => void,
  children: ReactNode,
}) {
  return (
    <button
      type="button"
      className={classes}
      onClick={() => handleDialogToggle(true)}
    >
      {children}
    </button>
  );
}
